import { useContext, useEffect, useState } from "react"
import Container from "../../../../layouts/containers/container";
import PopupContext from "../../../../context/context-popup"
import Row from "../../../../components//row";
import { ButtonCancel, ButtonModify, ButtonReturn, ButtonProceed } from "../../../../components/buttons";

import { useMediaQuery } from 'react-responsive';

import CalenderComponent from "./calender";
import Blurred from "../../../../components/blurred";
import List from "../../../../components/list";

import dayjs from "dayjs";
import moment from 'moment';

import { stringToFriendlyDatetime, stringToDatetimeLocal, getDSTLocalTime } from "../../../../lib/helpers/datetime-helpers";
import meetingsApi from "../../../../lib/meetings/meetings-api";
import InputsCheckbox from "../../../../components/inputs/inputs-checkbox";

const NumberedLabel = ({ number, label }) => {
    return (
        <div className="numbered-label">
            <div className="numbered-label__number">{ number }</div>
            { label }
        </div>
    )
}

const Calender = ({ data, spaceId, loading, onDaySelection, value, onContinue }) => {
    const isDesktopOrMobile = useMediaQuery({
        query: '(min-width: 1200px)'
    });

    return (
        <div className="date-time-popup__calender">
            <List gap="20px">
                <NumberedLabel number={1} label="Select date for this meeting"/>
                <CalenderComponent spaceId={spaceId} data={data} loading={loading} onDaySelection={onDaySelection} value={value}/>
            </List>
            { !isDesktopOrMobile && value !== undefined && <ButtonProceed responsive={false} onClick={onContinue}>Continue</ButtonProceed> }
        </div>
    )
}

const Time = ({
    day,
    value,
    space,
    onDateCreation,
    setPageView,
    timeOfDay, 
    setTimeOfDay,
}) => {
    const isDesktopOrMobile = useMediaQuery({
        query: '(min-width: 1200px)'
    });

    let time = ``;

    if (timeOfDay?.morning_session == true) {
        time = 'Morning'
    }

    if (timeOfDay?.afternoon_session == true) {
        time = 'Afternoon'
    }

    if (timeOfDay?.morning_session == true && timeOfDay?.afternoon_session == true) {
        time = 'All Day'
    }

    return (
        <div className="date-time-popup__time">
            <div className="date-time-popup__times">
                <Blurred toggled={day === null}>
                    <Row gap="40px" justifyContent="space-between" className="date-time-popup-times__time">
                        <NumberedLabel number={2} label="Which sessions would you like?"/>
                        <List gap="20px">
                            <Blurred toggled={day?.morning_session_available === false}>
                                <InputsCheckbox
                                    color="dark"
                                    checked={timeOfDay.morning_session}
                                    onChange={e => {
                                        setTimeOfDay({
                                            ...timeOfDay,
                                            morning_session: !timeOfDay.morning_session
                                        })
                                    }}
                                    text="In the Morning"
                                />
                            </Blurred>
                            <Blurred toggled={day?.afternoon_session_available === false}>
                                <InputsCheckbox
                                    color="dark"
                                    checked={timeOfDay.afternoon_session}
                                    onChange={e => setTimeOfDay({
                                        ...timeOfDay,
                                        afternoon_session: !timeOfDay.afternoon_session
                                    })}
                                    text="In the Afternoon"
                                />
                            </Blurred>
                        </List>
                    </Row>
                </Blurred>
            </div>

            <div className="date-time-popup__information">
                <List gap="20px">
                    <Container.Text color="#1577EA" fontSize="16px">Summary</Container.Text>
                    <div className="date-time-popup-information__details">
                        <Row gap="10px">
                            <Container.Text color="#354859" fontSize="16px">Space</Container.Text>
                            <Container.Text color="#1577EA" fontSize="16px">{ space?.name }</Container.Text>
                        </Row>

                        <Row gap="10px">
                            <Container.Text color="#354859" fontSize="16px">Date</Container.Text>
                            <Container.Text color="#1577EA" fontSize="16px">{ dayjs(day?.date).format('DD/MM/YYYY') || '--/--/--' }</Container.Text>
                        </Row>

                        <Row gap="10px">
                            <Container.Text color="#354859" fontSize="16px">Session(s)</Container.Text>
                            <Container.Text color="#1577EA" fontSize="16px">{ time || 'None Selected' }</Container.Text>
                        </Row>
                    </div>
                </List>

                <Row justifyContent='space-between'>
                    { !isDesktopOrMobile && <ButtonReturn mobile onClick={() => setPageView(0)}/> }
                    <Blurred toggled={day === null || (timeOfDay?.afternoon_session === false && timeOfDay?.morning_session === false)}>
                        <ButtonModify onClick={onDateCreation}>Confirm</ButtonModify>
                    </Blurred>
                </Row>
            </div>
        </div>
    )
}

export default function DateTimeInputPopup({
    onChange = () => {},
    value,
    space,
    data,
}) {
    const { closePopup } = useContext(PopupContext);

    const [ day, setDay ] = useState(null);
    const [ pageView, setPageView ] = useState(0);
    const [ initialValue, setInitialValue ] = useState(true);

    const {
        start,
        morning_session = null,
        afternoon_session = null,
    } = value;

    const [ timeOfDay, setTimeOfDay ] = useState({
        morning_session,
        afternoon_session
    });

    const isDesktopOrMobile = useMediaQuery({
        query: '(min-width: 1200px)'
    });

    const onContinue = () => {
        if (start === undefined || timeOfDay === undefined) return;

        const day = dayjs(start).startOf('day').format('YYYY-MM-DDTHH:mm');

        let params = {}

        onDaySelection({
            date: dayjs(start).format('YYYY-MM-DD'),
        });
    }

    const onDaySelection = (data) => {
        setDay(data);
        setPageView(1);

        if (initialValue) return setInitialValue(false);

        setTimeOfDay({
            morning_session: false,
            afternoon_session: false,
        })
    }

    const onDateCreation = () => {
        let params = {
            start: day,
            ...timeOfDay,
        };

        onChange(params);

        closePopup();
    }

    return (
        <div className="date-time-popup__outer">
            <Container className="date-time-popup">
                <Container.Header className="date-time-popup__head">
                    <Row gap="20px" justifyContent="space-between" alignItems="center">
                        <Container.Text color="#1577EA" fontSize="20px">Meeting scheduler for { space?.name }</Container.Text>
                        <ButtonReturn mobile onClick={closePopup}/>
                    </Row>
                </Container.Header>

                <Container.Content className="date-time-popup__content">
                    { isDesktopOrMobile && <>

                        <Calender spaceId={space.id} onDaySelection={onDaySelection} value={start} data={data}/>
                        <Time
                            timeOfDay={timeOfDay}
                            setTimeOfDay={setTimeOfDay}
                            space={space}
                            value={value}
                            day={day}
                            onDateCreation={onDateCreation}
                        />
                    </> }

                    { !isDesktopOrMobile && <>

                        { pageView === 0 && <Calender spaceId={space.id} onContinue={onContinue} loading={true} onDaySelection={onDaySelection} value={start} data={data}/> }
                        { pageView === 1 && <Time
                            setPageView={setPageView}
                            timeOfDay={timeOfDay}
                            setTimeOfDay={setTimeOfDay}
                            value={value}
                            space={space}
                            day={day}
                            onDateCreation={onDateCreation}
                        /> }
                    </>}
                </Container.Content>
            </Container>
        </div>
    )
}
